// File 1: ChatHeader.js
import React from "react";
import { Box, IconButton, Avatar, Typography } from "@mui/material";
import { ArrowBackIos, Call } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const ChatHeader = ({ coachData, cartPageNavigation, handleBackButtonPress }) => {
    const navigate = useNavigate();
    
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                padding: "10px",
                background: "linear-gradient(90deg, #fff 0%, rgba(255, 152, 0, 0.11) 70%)",
                color: "black",
                borderRadius: "5px",
                justifyContent: "space-between",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <IconButton
                    sx={{ color: "#771615" }}
                    onClick={handleBackButtonPress}
                >
                    <ArrowBackIos />
                </IconButton>
                <Avatar
                    alt="Coach"
                    src={coachData.coachPlanInfo.coachImage}
                    sx={{ width: 40, height: 40, marginRight: "10px" }}
                />
                <Box>
                    <Typography variant="body1" sx={{ fontWeight: "bold", color: "#771615" }}>
                        {coachData.coachPlanInfo.coachName}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            fontSize: "12px",
                            color:
                                coachData.coachPlanInfo.coachStatus === "Online"
                                    ? "green"
                                    : "red",
                        }}
                    >
                        ⦿ {coachData.coachPlanInfo.coachStatus}
                    </Typography>
                </Box>
            </Box>

            <IconButton
                sx={{ color: "#771615" }}
                onClick={cartPageNavigation}
            >
                <Call />
            </IconButton>
        </Box>
    );
};

export default ChatHeader;
